import './Spinner.less';

export const Spinner: React.FC = ({ children }) => {
	return (
		<div className='spinner'>
			<img
				src={process.env.PUBLIC_URL + '/logo.png'}
				className='msp-splash-logo'
				alt='My Spending Planner'
			/>
			{children && <div className='fzn-splash-text'>{children}</div>}
		</div>
	);
};
